import { documentPurposes } from "@quest-finance/quest-fe-shared/dist/application";
import { Dictionary } from "@quest-finance/quest-fe-shared/dist/common/types/Dictionary";

export const DOCUMENT_PURPOSE_LABEL: Dictionary = {
  [documentPurposes.DOCUMENT_PURPOSES.SUPPORTING_DOCUMENT]:
    "Supporting document",
  [documentPurposes.DOCUMENT_PURPOSES.SETTLEMENT_DOCUMENT]:
    "Settlement document",
};
